module.exports = __webpack_public_path__ + "static/media/Sam (Child).8d1b2103.jpg";